module.exports = __webpack_public_path__ + "img/logo-cotizacion.9fb3d14b.png";